import React, { createContext, useContext } from 'react';
import { useAppControllerGetMeQuery } from 'src/store/leela-api';
import type { UserContextDto } from 'src/store/generated/leela-api-generated';

interface UserContextType {
  user: UserContextDto | undefined;
  isLoading: boolean;
  isError: boolean;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data: user, isLoading, isError } = useAppControllerGetMeQuery();

  return (
    <UserContext.Provider value={{ user, isLoading, isError }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
